"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-delete-16><path fill-rule=evenodd clip-rule=evenodd d="m4.22 4 .526-2.106A2.5 2.5 0 0 1 7.171 0H8.83a2.5 2.5 0 0 1 2.425 1.894L11.781 4H15a1 1 0 1 1 0 2h-1.095l-.775 7.749A2.5 2.5 0 0 1 10.643 16H5.358a2.5 2.5 0 0 1-2.488-2.25L2.095 6H1a1 1 0 0 1 0-2h3.22Zm2.466-1.621A.5.5 0 0 1 7.171 2H8.83a.5.5 0 0 1 .485.379L9.72 4H6.281l.405-1.621ZM4.98 6h6.915l-.755 7.55a.5.5 0 0 1-.497.45H5.358a.5.5 0 0 1-.498-.45L4.105 6h.874Z"></path></symbol>';
}
